import { HTML_FONT_SIZE, COEF } from './settings'

// transform pixel to rem
// https://snook.ca/archives/html_and_css/font-size-with-rem
export const pxToRem = (size) => `${(size / HTML_FONT_SIZE) * COEF}rem`
